import React, { useState, useEffect } from "react";
import { Box, Button, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import { api } from "../utils/api.ts";

interface User {
  id: number;
  login: string;
  admin?: boolean;
}

interface UserMenuProps {
  user: User;
  displayedUser: User;
  onLogout: () => void;
  onSwitchUser: (user: User | null) => void;
}

const UserMenu: React.FC<UserMenuProps> = ({ user, displayedUser, onLogout, onSwitchUser }) => {
  const [allUsers, setAllUsers] = useState<User[]>([]);
  const [selectedUserId, setSelectedUserId] = useState(displayedUser.id);

  useEffect(() => {
    setSelectedUserId(displayedUser.id);
  }, [displayedUser.id]);

  useEffect(() => {
    if (user.admin) {
      api
        .get("/api/users")
        .then((res) => setAllUsers(res.data))
        .catch((err) => console.error("Failed to load users:", err));
    } else {
      setAllUsers([]);
    }
  }, [user.admin]);

  const handleLogout = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await api.post("/api/logout");
    } finally {
      onLogout();
    }
  };

  const handleUserChange = (event: any) => {
    const newId = Number(event.target.value);
    setSelectedUserId(newId);
    const selected = allUsers.find((u) => u.id === newId);
    if (selected) onSwitchUser(selected);
  };

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {user.admin && (
          <>
            <FormControl fullWidth>
              <InputLabel id="switch-user-label">User</InputLabel>
              <Select labelId="switch-user-label" value={selectedUserId} label="Switch User" onChange={handleUserChange}>
                {allUsers.map((u) => (
                  <MenuItem key={u.id} value={u.id}>
                    {u.login}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Button
              variant="outlined"
              fullWidth
              onClick={() => {
                setSelectedUserId(user.id);
                onSwitchUser(null);
              }}
              disabled={selectedUserId === user.id}
            >
              Reset to Myself
            </Button>
          </>
        )}
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Button variant="outlined" startIcon={<SettingsIcon />} fullWidth onClick={() => alert("Settings placeholder")}>
          Settings
        </Button>

        <Button variant="contained" color="error" startIcon={<LogoutIcon />} fullWidth onClick={handleLogout}>
          Logout
        </Button>
      </Box>
    </Box>
  );
};

export default UserMenu;
